import { render, staticRenderFns } from "./RegistratieAanpassen.vue?vue&type=template&id=114c8e07&scoped=true&"
import script from "./RegistratieAanpassen.vue?vue&type=script&lang=js&"
export * from "./RegistratieAanpassen.vue?vue&type=script&lang=js&"
import style0 from "./RegistratieAanpassen.vue?vue&type=style&index=0&id=114c8e07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c8e07",
  null
  
)

export default component.exports